"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ZoomMarker {
    constructor(map, markers) {
        this.map = map;
        this.markers = markers;
    }
    zoom(marker) {
        this.map.flyTo(marker.getLatLng(), 16, {
            animate: true,
            duration: 1
        });
        setTimeout(function () {
            marker.openPopup();
        }, 1200);
    }
}
exports.default = ZoomMarker;
